<template>
  <div class="spinner" :class="sizeClass">
    <div class="spinner__circle"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'

export default defineComponent({
  name: 'Spinner',
  props: {
    size: {
      type: String,
      default: 'medium',
      validator: (value: string) => ['small', 'medium', 'large'].includes(value)
    }
  },
  setup(props) {
    const sizeClass = computed(() => `spinner--${props.size}`)

    return {
      sizeClass
    }
  }
})
</script>

<style lang="scss" scoped>
.spinner {
  display: inline-block;
  position: relative;

  &__circle {
    display: block;
    width: 100%;
    height: 100%;
    border: 2px solid #e0e0e0;
    border-top-color: var(--primary-color, #000);
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }

  &--small {
    width: 1rem;
    height: 1rem;

    .spinner__circle {
      border-width: 2px;
    }
  }

  &--medium {
    width: 1.5rem;
    height: 1.5rem;

    .spinner__circle {
      border-width: 2px;
    }
  }

  &--large {
    width: 2rem;
    height: 2rem;

    .spinner__circle {
      border-width: 3px;
    }
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
